import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { enUS } from 'date-fns/locale/en-US';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { ErrorComponent } from '@barboxx/admin-components';

import '../config/api';

import { NotificationsProvider } from '@toolpad/core';

import { AuthProvider } from '@barboxx/admin-utils';
import { ability, AbilityContext } from '@barboxx/react-utils';

import { BarBoxxRoutes } from './Routes';
import theme from './theme';

const REACT_QUERY_CLIENT = new QueryClient();

export default function App() {
    const handleLogout = () => {
        REACT_QUERY_CLIENT.clear();
    };

    return (
        <ThemeProvider theme={theme}>
            <Sentry.ErrorBoundary fallback={ErrorComponent}>
                <CssBaseline />
                <QueryClientProvider client={REACT_QUERY_CLIENT}>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={enUS}
                    >
                        <NotificationsProvider
                            slotProps={{
                                snackbar: {
                                    autoHideDuration: 3000,
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    },
                                },
                            }}
                        >
                            <AbilityContext.Provider value={ability}>
                                <AuthProvider onLogOut={handleLogout}>
                                    <BarBoxxRoutes />
                                </AuthProvider>
                            </AbilityContext.Provider>
                        </NotificationsProvider>
                    </LocalizationProvider>
                </QueryClientProvider>
            </Sentry.ErrorBoundary>
        </ThemeProvider>
    );
}
